<ng-container *ngFor="let field of fields">

  <!-- Text field -->
  <div class="form-group" *ngIf="!field.model.isBoolean">
    <label for="{{ field.name }}">{{ field.model.comment || field.name }}</label>

    <input id="{{ field.name }}" type="text" [(ngModel)]="field.value" />

    <span class="info info-right">{{ field.name }}</span>
  </div>

  <!-- Boolean field -->
  <div class="form-group" *ngIf="field.model.isBoolean">
    <label for="{{ field.name }}">{{ field.model.comment || field.name }}</label>
    <t-option [options]="booleanOptions" [(value)]="field.value"></t-option>
    <span class="info info-right">{{ field.name }}</span>
  </div>

</ng-container>